export function updateStatusBarColor(color: string): void {
    // Función para detectar si la app está en modo standalone
    // Función para detectar si la app está en modo standalone
    const isInStandaloneMode = (): boolean =>
      window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone;

      // Cambiar el theme color en Android
        let themeColorMetaTag: HTMLMetaElement | null = document.querySelector('meta[name=theme-color]');
        if (themeColorMetaTag) {
          themeColorMetaTag.remove(); // Elimina el meta tag existente
        }
        themeColorMetaTag = document.createElement('meta');
        themeColorMetaTag.name = 'theme-color';
        themeColorMetaTag.content = color;
        document.head.appendChild(themeColorMetaTag); 
}
  
  